export default {"src":"/_next/static/media/Merchandise.cc459374.svg","height":92,"width":91};